/* eslint-disable valid-jsdoc */
import { createContext, useContext } from "react";

/**
 * @template ContextDefinition
 * @template HooksDefinition
 * @param {(args: HooksDefinition) => ContextDefinition} useFactory
 */
export default function createContextFactory(useFactory) {
  /**
   * @type {ContextDefinition}
   */
  const initialValue = {}
  const Context = createContext(initialValue)
  const useFactoryContext = () => useContext(Context)

  /**
   * @param {HooksDefinition&{children: React.ReactNode}} props
   */
  const Provider = ({ children, ...props }) => {
    const value = useFactory(props)

    return <Context.Provider value={value}>
      {children}
    </Context.Provider>
  }

  return {
    Provider,
    useContext: useFactoryContext,
  }
}

